import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  AlertTitle,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress
} from "@mui/material";
import JoditEditorExample from "../../helpers/JoditEditorExample";
import moment from "moment";
import { SubmitButton } from "../buttons";
import React, { useState } from "react";
import { Add } from "@material-ui/icons";
import CustomDateInput from "../../helpers/DateInput";
import { showError } from "../../helpers/ShowError";

const EditMeeting = (props) => {
  const {
    start,
    end,
    setStart,
    setEnd,
    name,
    setName,
    type,
    setType,
    venue,
    setVenue,
    room,
    setRoom,
    rooms,
    agenda,
    setAgenda,
    reminder,
    setReminder,
    onSubmit,
    setLoading,
    loading,
    errorMessage,
    validationMessage,
    field,
    setField,
    systemSettings,
    Room
  } = props;
  const mainBackground = systemSettings?.mainBackground;

  const [select, setSelect] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const roomList = rooms || [];
  const roomExists = roomList?.some((r) => r.id === Room?.id);
  const finalRoomOptions = roomExists ? roomList : [...roomList, Room];



  let history = useHistory();

  const getDuration = () => {
    let days = moment(end).diff(moment(start), "days");
    let msg = null;
    if (days < 0) {
      return {
        error: true,
        message: "End date has to be greater than start date",
      };
    } else if (days === 0) {
      let hours = moment(end).diff(moment(start), "hours");

      if (hours <= 0) {
        let minutes = moment(end).diff(moment(start), "minutes");
        msg = msg ?? `${minutes} minutes`;
      }

      msg = msg ?? `${hours} hours`;
    }

    msg = msg ?? `${days} days`;
    return {
      error: false,
      message: `Meeting duration is ${msg}`,
      duration: msg,
    };
  };

  let dur = getDuration();

  return (
    <div>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb flex items-center">
          <li className="breadcrumb-item pageTitle">
            <Link to="/admin/meeting" className="text-white text-decoration-none">
              Meeting  /
            </Link>
          </li>
          <li className="breadcrumb-item active pageTitle ml-1" aria-current="page">
            Edit
          </li>
        </ol>
      </nav>
      <div>
        <Card className="mt-4">
          <CardHeader
            titleTypographyProps={{ variant: "h6" }}
            action={
              <div>
                <span className="fs-6 text-danger">{errorMessage}</span>
              </div>
            }
          />
          <CardContent>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="mb-3 grid grid-cols-2 gap-2">
                  <div>
                    <label className="col-form-label fw-bold text-capitalize">
                      Meeting Name
                      <span className="text-danger fs-6">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      value={name}
                      required={true}
                      onBlur={() => {
                        setField("name");
                      }}
                      onChange={(event) => setName(event.target.value)}
                    />
                    {field === "name" && showError(field, validationMessage)}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="col-form-label fw-bold text-capitalize">
                      Start
                      <span className="text-danger fs-6">*</span>
                    </label>
                    <div className="">
                      <input
                        type="datetime-local"
                        name="start"
                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={start}
                        required={true}
                        onBlur={() => {
                          setField("start");
                        }}
                        onChange={(event) => {
                          setStart(event.target.value);
                          setField("start");
                        }} />
                    </div>
                    {field === "start" && showError(field, validationMessage)}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="col-form-label fw-bold text-capitalize">
                      End
                      <span className="text-danger fs-6">*</span>
                    </label>
                    <div>
                      <input
                        type="datetime-local"
                        name="end"
                        className="form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={end}
                        required={true}
                        onBlur={() => {
                          setField("end");
                        }}
                        onChange={(event) => {
                          setEnd(event.target.value);
                        }} />
                    </div>
                    {field === "end" && showError(field, validationMessage)}
                  </div>
                  {start && end ? (
                    <div className={"col-md-12"}>
                      <Alert
                        severity={dur.error ? "error" : "success"}
                        variant={"outlined"}
                      >
                        <AlertTitle>Start - End duration</AlertTitle>
                        {dur.message}
                      </Alert>
                    </div>
                  ) : null}

                  <div className="col-md-6 mb-3">
                    <div className={"flex justify-between"}>
                      <div className={"flex-grow-1"}>
                        <label className="col-form-label fw-bold text-capitalize" required>
                          Meeting Rooms
                          <span className="text-danger fs-6">*</span>
                        </label>
                      </div>
                      <div>
                      </div>
                    </div>
                    <select
                      value={room}
                      className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      required={true}
                      onChange={(e) => setRoom(e.target.value)}>

                      <option value="">Select---</option>
                      {finalRoomOptions?.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {/* <select
                      value={room}
                      className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      onBlur={() => {
                        setField("venue");
                      }}
                      onChange={(e) => setRoom(e.target.value)}>
                      <option selected value={""}>
                        {"Select---"}
                      </option>
                      {rooms?.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select> */}

                    {field === "venue" && showError(field, validationMessage)}
                  </div>

                  <div>
                    <label className="col-form-label fw-bold text-capitalize">
                      Reminder
                      <span className="text-danger fs-6">*</span>
                    </label>
                    <select
                      value={reminder}
                      id="reminder"
                      className="form-select px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      required={true}
                      onChange={(e) => setReminder(e.target.value)}>
                      <option selected>{"Select..."}</option>
                      {[
                        { name: 15, label: "15 min before" },
                        { name: 30, label: "30 min before" },
                        { name: 60, label: "1 hour before" },
                        { name: 1, label: "1 day before" },
                      ].map((item) => (
                        <option value={item.name}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <Card className={"mt-3 mb-3"} variant={"outlined"}>
              <CardHeader
                title={"Agenda"}
                titleTypographyProps={{ variant: "h6" }}
              />
              <CardContent>
                <JoditEditorExample
                  htmlContent={agenda}
                  onBlur={(str) => {
                    setAgenda(str.target.value);
                  }}
                />
              </CardContent>
            </Card>
          </CardContent>
          <CardActions className={"float-end"}>
            <Button color={"error"} onClick={() => history.goBack()}>
              Cancel
            </Button>
            {loading ? (
              <CircularProgress />
            ) : (
              <SubmitButton
                name="Apply Change"
                handleAction={() => {
                  setLoading(true);
                  return onSubmit(dur.duration);
                }}
                handleClick={() => setSelect(true)}
                confirm={select}
                setConfirm={setSelect}
              />
            )}
          </CardActions>
        </Card>
      </div>
    </div>
  );
};
export default EditMeeting;
